import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'semantic-ui-react';
import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';
import { escribirMonto } from '../../../utilidades';
import {
    ApoderadosDeudoresCobrosCalculados,
    DatosApoderado,
    ObtenerApoderadosDeudoresDeCobrosCalculadosResp,
} from '../../tipos';
import MenuTabla, { Filtro } from './MenuTabla';

type Datos = ObtenerApoderadosDeudoresDeCobrosCalculadosResp;

interface Props {
    readonly ocultar: boolean;
}

interface State {
    readonly datos: Datos;
    readonly idsFiltrados: ReadonlyArray<string>;
    readonly cargando: boolean;
    readonly filtro: Filtro;
}

const stateInicial: State = {
    datos: {
        porId: {},
        todosLosId: [],
    },
    idsFiltrados: [],
    cargando: true,
    filtro: 'todos',
};

class GastosNotarialesYAbonos extends React.Component<Props, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state = stateInicial;

    public componentDidMount() {
        if (!this.props.ocultar) {
            this.traerApoderados();
        }
    }

    public componentDidUpdate(prevProps: Props) {
        if (!this.props.ocultar && prevProps.ocultar) {
            this.traerApoderados();
        }
    }

    public render() {
        if (this.props.ocultar) return null;
        const { datos, idsFiltrados, cargando, filtro } = this.state;

        const datosFiltrados = idsFiltrados.map(id => datos.porId[id]!);

        return (
            <div>
                <MenuTabla
                    cantidadDeApoderados={datosFiltrados.length}
                    cargando={cargando}
                    alPresionarRecargar={this.traerApoderados}
                    filtro={filtro}
                    alCambiarFiltro={this.establecerFiltro}
                />

                <Table celled structured attached='bottom'>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell rowSpan='2'>Apoderado</Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2'>Forma de pago</Table.HeaderCell>
                            <Table.HeaderCell colSpan='2' textAlign='center'>
                                Deudas
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell>Tipo</Table.HeaderCell>
                            <Table.HeaderCell>Monto adeudado</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {datosFiltrados.map(apoderado => {
                            const [cobro1, cobro2] = apoderado.cobrosCalculados;

                            return (
                                <React.Fragment key={apoderado.id}>
                                    <Table.Row>
                                        <Table.Cell
                                            selectable
                                            rowSpan={apoderado.cobrosCalculados.length}
                                        >
                                            <Link to={`/cobranzas/plan/${apoderado.id}`}>
                                                <b>{apoderado.nombreCompleto}</b>
                                            </Link>
                                        </Table.Cell>
                                        <Table.Cell rowSpan={apoderado.cobrosCalculados.length}>
                                            {nombresFormasPago[apoderado.formaDePago]}
                                        </Table.Cell>
                                        <Table.Cell>{nombreTipoCobro[cobro1.tipo]}</Table.Cell>
                                        <Table.Cell>
                                            {escribirMonto(cobro1.montoRestante)}
                                        </Table.Cell>
                                    </Table.Row>
                                    {cobro2 && (
                                        <Table.Row>
                                            <Table.Cell>{nombreTipoCobro[cobro2.tipo]}</Table.Cell>
                                            <Table.Cell>
                                                {escribirMonto(cobro2.montoRestante)}
                                            </Table.Cell>
                                        </Table.Row>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </Table.Body>
                </Table>
            </div>
        );
    }

    private readonly establecerFiltro = (filtro: Filtro) => {
        const { porId, todosLosId } = this.state.datos;

        this.setState({
            filtro,
            idsFiltrados: filtrar(filtro, todosLosId, porId),
        });
    };

    private readonly traerApoderados = () => {
        this.setState({ cargando: true });
        clienteApi
            .ejecutar('obtenerApoderadosDeudoresDeCobrosCalculados')
            .then(({ porId, todosLosId }) => {
                // Ordena alfabéticamente por nombre
                const idsFiltrados = filtrar(this.state.filtro, todosLosId, porId);
                idsFiltrados.sort((idA, idB) =>
                    porId[idA]!.nombreCompleto.localeCompare(porId[idB]!.nombreCompleto, 'es'),
                );
                this.setState({
                    cargando: false,
                    datos: { porId, todosLosId },
                    idsFiltrados,
                });
            })
            .catch(error => {
                this.context.mostrarModalError(error);
                this.setState(stateInicial);
            });
    };
}

const nombresFormasPago: Record<DatosApoderado['tipoDeFormaDePago'], string> = {
    contado: 'Contado',
    tarjeta: 'Tarjeta',
    cheque: 'Cheque',
    pagare: 'Pagaré',
};

const nombreTipoCobro: Record<
    ApoderadosDeudoresCobrosCalculados['cobrosCalculados'][number]['tipo'],
    string
> = {
    'gasto-notarial': 'Gasto notarial',
    'abono-inicial': 'Abono inicial',
};

function filtrar(filtro: Filtro, todosLosId: Datos['todosLosId'], porId: Datos['porId']) {
    if (filtro === 'todos') return todosLosId;

    const filtroTraducido = filtro === 'soloGastosNotariales' ? 'gasto-notarial' : 'abono-inicial';
    return todosLosId.filter(id =>
        porId[id]!.cobrosCalculados.some(cobro => cobro.tipo === filtroTraducido),
    );
}

export default GastosNotarialesYAbonos;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Deudores/componentes/DeudoresCobrosCalculados/GastosNotarialesYAbonos.tsx